import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import SmartRender from "containers/SmartRender";
import get from "lodash/get";

import { createStructuredSelector } from "reselect";
import {
  makeSelectOrderActionStatusMessageData,
  makeSelectGuestOrder
} from "ducks/selectors";

const OrderActionGenericStatus = Component =>
  function Comp(props) {
    return (
      <Component
        {...props}
        messageData={{ ...get(props, "genericStatusMessageData", {}) }}
      />
    );
  };

const mapStateToProps = createStructuredSelector({
  genericStatusMessageData: makeSelectOrderActionStatusMessageData(),
  order: makeSelectGuestOrder()
});

export function mapDispatchToProps(dispatch) {
  return {};
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(withConnect)(OrderActionGenericStatus(SmartRender));
